import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LoadingStyles from "./Loading.module.css";

function Loading(Page) {
  const HOC = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
      setIsLoading(true);
      const timeoutId = window.setTimeout(() => setIsLoading(false), 5000);
      return () => window.clearTimeout(timeoutId);
    }, [pathname]);

    return (
      <>
        <div
          className={`${LoadingStyles.container} ${
            isLoading ? "" : LoadingStyles.hidden
          }`}
          aria-hidden={!isLoading}
          role="status"
          aria-label="Loading ProfitGrowing"
        >
          <div className={LoadingStyles.brand}>
            <span className={LoadingStyles.mark} aria-hidden="true">
              <svg viewBox="0 0 32 32" fill="none">
                <path d="m6 22 7-7 5 4 8-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 9h6v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <span className={LoadingStyles.wordmark}>Profit<span>Growing</span></span>
          </div>
          <div className={LoadingStyles.spinner} aria-hidden="true"></div>
          <p>Preparing your account view</p>
        </div>
        <Page {...props} />
      </>
    );
  };
  return HOC;
}

export default Loading;
